module.exports = __webpack_public_path__ + "img/Frame-36.9652320e.svg";